


















import { Component, Prop, Vue } from 'vue-property-decorator'
import TitleEditor, { EditorTracker } from '@/components/TitleEditor.vue'
import store from '@/store'
import { Card } from '@alpha/ink'
import { Question, Response } from '@/store/modules/survey-store-module'
import { TrackKeys } from '@/utilities/v-track-directive'

@Component({
  components: {
    TitleEditor,
    Card
  }
})
export default class QuestionTitleEditor extends Vue {
  @Prop({ required: true }) question!: Question & { responses: Response[] }

  currentValue:string = this.currentTitle
  saving: boolean = false
  track: EditorTracker = {
    input: TrackKeys.questionTitleInput,
    save: TrackKeys.questionTitleSave,
    cancel: TrackKeys.questionTitleCancel,
    revert: TrackKeys.questionConfigRevert
  }

  get config () {
    const questionConfig = store.getters.surveyConfiguration.questionConfigById(this.question.id)
    return {
      value: questionConfig.title
    }
  }

  // Quesiton Title Config Specific Methods
  updateQuestionConfigTitleValue (value: string) {
    this.currentValue = value
  }

  cancelQuestionConfigTitle () {
    this.currentValue = this.currentTitle
    this.setTitleEditMode(false)
  }

  async revertQuestionConfigTitle () {
    if (this.currentValue !== this.question.text) {
      this.currentValue = this.question.text
    } else if (this.config?.value && this.config.value !== this.currentValue) {
      this.currentValue = this.config.value
    }
  }

  async saveQuestionConfigTitle () {
    this.saving = true
    try {
      if (this.question.text === this.currentValue) {
        await store.dispatch.surveyConfiguration.deleteQuestionText({ questionId: this.question.id, type: 'title' })
      } else {
        await store.dispatch.surveyConfiguration.updateQuestionConfig({ questionId: this.question.id, title: this.currentValue })
        this.currentValue = this.currentTitle
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.saving = false
      this.setTitleEditMode(false)
    }
  }

  get currentTitle () {
    return this.config.value || this.question.text || ''
  }

  setTitleEditMode (mode: boolean) {
    this.$emit('setTitleEditMode', mode)
  }
}
